(ns hai.library.sources.utils
  "Shared utilities for sources management")

(defn all-sources-finished?
  [rows]
  (if (empty? rows)
    true
    (every? #(not (:ai-source/in-progress? %)) rows)))
